import type { InputHTMLAttributes, ReactNode } from 'react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  icon?: ReactNode
}

export function Input({ label, error, icon, id, className = '', ...rest }: InputProps) {
  const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-')

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={inputId} className="text-sm font-medium text-slate-700 dark:text-slate-300">
          {label}
        </label>
      )}
      <div className="relative">
        {icon && (
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none">
            {icon}
          </span>
        )}
        <input
          id={inputId}
          {...rest}
          className={[
            'w-full rounded-lg border border-slate-300 bg-white text-slate-900',
            'placeholder:text-slate-400 text-sm',
            'focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent',
            'dark:bg-slate-800 dark:border-slate-600 dark:text-slate-100 dark:placeholder:text-slate-500',
            'disabled:opacity-50 disabled:cursor-not-allowed',
            icon ? 'pl-9 pr-3 py-2' : 'px-3 py-2',
            error ? 'border-danger focus:ring-danger' : '',
            className,
          ].join(' ')}
        />
      </div>
      {error && <p className="text-xs text-danger">{error}</p>}
    </div>
  )
}
